import React, { useContext } from 'react';
import S from "./ReturnsYearly.styled";
import CardHeader from "../CardHeader";
import FundContext from '@/components/FundSingle/FundProvider';
import Table from "../../../Table/index";
import moment from 'moment';

import Quartile1 from "@/assets/quartile/Quartile_1.svg";
import Quartile2 from "@/assets/quartile/Quartile_2.svg";
import Quartile3 from "@/assets/quartile/Quartile_3.svg";
import Quartile4 from "@/assets/quartile/Quartile_4.svg";

const quartileImages = {
    1: Quartile1,
    2: Quartile2,
    3: Quartile3,
    4: Quartile4,
};

const ReturnsYearly: React.FC<FundSingle> = () => {
    const { fundCompareBenchmarkData, fundRiskDetails } = useContext(FundContext);
    
    if (!fundCompareBenchmarkData) return null;

    const dataDate = fundRiskDetails.KID.Date;
    const fondReturns = fundRiskDetails.HistoricalPerformanceSeries.find((item: any) => item.ReturnType === 'Nav' && item.Frequency === 'Y').Return;
    const benchmarkReturns = fundRiskDetails.Benchmark.find((item: any) => item.Type === 'Category')
        .HistoricalPerformanceSeries.find((item: any) => item.ReturnType === 'Nav' && item.Frequency === 'Y').Return;
    const historicalPeerGroupRanks = fundRiskDetails.HistoricalPeerGroupRanks;

    fondReturns.splice(8);
    benchmarkReturns.splice(8);
    historicalPeerGroupRanks && historicalPeerGroupRanks.splice(8);

    const rankingInCategory = historicalPeerGroupRanks?.map((item: any) => item.PeerGroupRankDetails[0].PercentileRank) || [];

    while (rankingInCategory.length < 8) {
        rankingInCategory.push(0);
    }

    fondReturns.reverse();
    benchmarkReturns.reverse();
    historicalPeerGroupRanks && historicalPeerGroupRanks.reverse();

    const headings = fondReturns.map((item: any) => moment(item.Date).format('Y'));

    const tableData = {
        headings: ['', ...headings],
        rows: [
            ['Fond', fondReturns.map((item: any) => item.Value !== undefined ? item.Value.toFixed(2) : '-')],
            ['Kategori', benchmarkReturns.map((item: any) => item.Value !== undefined ? item.Value.toFixed(2) : '-')],
            ['% Rankning i kategori', rankingInCategory],
            ['Kvartil', rankingInCategory.map((value: number) => {
                let quartile = 4; // Default to 4 if no match
                if (value <= 25) quartile = 1;
                else if (value <= 50) quartile = 2;
                else if (value <= 75) quartile = 3;

                const QuartileImg = quartileImages[quartile];
                return <QuartileImg />;
            })]
        ]
    };

    return (
        <S.AllocationWrapper>
            <CardHeader title="Årlig avkastning % (SEK)" subTitle={moment(dataDate).format('YYYY-MM-DD')} />
            <Table tableData={tableData} />
        </S.AllocationWrapper>
    );
};

export default ReturnsYearly;
